/**
 * Colour Number Display for Empire Theme (v2 - swatches + dropdown)
 * Appends the colour number from custom.colour_number metafield to the
 * variant option label. Works with both swatch mode (legend text) and
 * dropdown mode (select options).
 *
 * Swatch mode: "Colour: Pink" becomes "Colour: Pink (1234)"
 * Dropdown mode: option "Pink" becomes "Pink (1234)"
 *
 * Only affects colour-variant products that have colour_number data
 * injected into the section data JSON by static-product.liquid.
 */
(function () {
  'use strict';

  var sectionDataEl = document.querySelector(
    'script[data-section-type="static-product"][data-section-data]'
  );
  if (!sectionDataEl) return;

  var sectionData;
  try {
    sectionData = JSON.parse(sectionDataEl.textContent);
  } catch (e) {
    return;
  }

  var colourNumbers = sectionData.variant_colour_numbers;
  if (!colourNumbers || typeof colourNumbers !== 'object') return;

  // Check if there's any data at all
  var hasAny = false;
  for (var key in colourNumbers) {
    if (colourNumbers.hasOwnProperty(key)) {
      hasAny = true;
      break;
    }
  }
  if (!hasAny) return;

  // --- Swatch mode ---
  var swatchFieldset = document.querySelector('.options-selection__swatches');
  if (swatchFieldset) {
    var optionNameSpan = swatchFieldset.querySelector('.options-selection__option-name');
    if (optionNameSpan) {
      // Append colour number to the label text
      function appendColourNumber() {
        var text = optionNameSpan.textContent;
        // Format is "Colour: ColourName" — extract the colour name
        var match = text.match(/^Colour:\s*(.+)$/);
        if (!match) return;
        var colourName = match[1].trim();

        // Skip if number already present (e.g. "Charcoal (9093)")
        if (/\(\d+\)$/.test(colourName)) return;

        var colourNum = colourNumbers[colourName];
        if (colourNum) {
          optionNameSpan.textContent = 'Colour: ' + colourName + ' (' + colourNum + ')';
        }
      }

      // Apply on initial load
      appendColourNumber();

      // Watch for Empire updating the text on swatch click
      var observer = new MutationObserver(function () {
        appendColourNumber();
      });
      observer.observe(optionNameSpan, { childList: true, characterData: true, subtree: true });
    }
    return; // Done — swatches and dropdowns are mutually exclusive
  }

  // --- Dropdown mode (fallback for non-swatch products) ---
  var colourSelect = document.querySelector(
    'select.options-selection__input-select[data-variant-option-index="0"]'
  );
  if (!colourSelect) return;

  for (var i = 0; i < colourSelect.options.length; i++) {
    var opt = colourSelect.options[i];
    var colourName = opt.value;
    var colourNum = colourNumbers[colourName];
    if (colourNum) {
      opt.textContent = colourName + ' (' + colourNum + ')';
    }
  }
})();
